import { useEffect } from 'react';
import {
  useBreadcrumbsContext,
  useHeaderContext,
} from '../../../../app/context';
import { NaturalPersonListPageContainer } from './styles';
import { NaturalPersonListPageContent } from './components';
import { useOriginatorContext } from 'modules/common/OriginatorProvider';
import IdCardIcon from 'app/components/Icons/IdCardIcon';

const NaturalPersonListPage = () => {
  const { setItems, resetBreadcrumbs } = useBreadcrumbsContext();
  const { setTitle, resetTitle } = useHeaderContext();
  const { setSelectedOriginator } = useOriginatorContext();

  useEffect(() => {
    setSelectedOriginator(null);
    setItems(
      [
        { to: '/records/natural', label: 'Cadastros' },
        { to: '/records/natural', label: 'Pessoas' },
      ],
      <IdCardIcon />,
    );
    return resetBreadcrumbs;
  }, []);

  useEffect(() => {
    setTitle('Pessoas');
    return resetTitle;
  }, []);

  return (
    <NaturalPersonListPageContainer>
      <NaturalPersonListPageContent />
    </NaturalPersonListPageContainer>
  );
};

export default NaturalPersonListPage;
